// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"296":"86ff1166","422":"88c51e29","797":"019506fe"}[chunkId] + ".css";
};